module.exports = [{
      plugin: require('../node_modules/gatsby-remark-code-buttons/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["de","en"],"defaultLanguage":"de","i18nextOptions":{"debug":false,"fallbackLng":"de","supportedLngs":["de","en"],"defaultNS":"common","interpolation":{"escapeValue":false},"keySeparator":"."},"pages":[{"matchPath":"/blog/:lang?/:slug/","getLanguageFromPath":true,"ignorelanguages":["de","en"]}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
